const isOnePersonCompany = (accountType: string): boolean =>
  accountType === 'one_person_company';

export default isOnePersonCompany;
